export default __webpack_public_path__ + "static/media/Qe_12.8c053dab.JPG";